<template>
  <transition name="fade">
    <div v-if="isVisible" class="notification-delivery">
      <!-- <button class="close-btn" @click="closeBoton">&times;</button> -->
      <div class="notification-content">
        <i class="fas fa-shipping-fast icon"></i>
        <strong>{{ $t('deliveryMessage') }}</strong>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'NotificationPrices',
  data() {
    return {
      isVisible: true,
    };
  },
  methods: {
    closeBoton() {
      this.isVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import './NotificationDelivery.styles.scss';
</style>
